<ng-container [ngSwitch]="code">
  <!--<div *ngSwitchCase="'au'">
    Author Filter works
  </div> -->
  <div *ngSwitchCase="'mrar'">
    <label for="year-select">Select Year:</label>
    <select id="year-select">
      <option *ngFor="let year of years" [value]="year">{{ year }}</option>
    </select>
  </div>
  <div *ngSwitchCase="'mrau'" class="p-4 h-full shadow-md">
    <div class="mb-6 border-2 border-gray-400 rounded-3xl p-3">
      <!-- Title -->
      <div
        class="text-lg flex justify-center font-bold text-gray-700 mb-4 border-b-2 border-gray-400"
      >
        FILTROS
      </div>

      <!-- Authors number -->
      <div class="mb-4 border-b-2 border-gray-400">
        <label for="authorsRange" class="block text-sm text-gray-700 mb-2 font-bold border-gray-400"
          >Número de autores</label
        >
        <div class="p-2 rounded-2xl border-gray-400">
          <input
            id="authorsRange"
            type="range"
            class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
            min="10"
            max="200"
            step="10"
          />
          <label for="authorsRange" class="block text-sm text-gray-500 font-bold mt-2"
            >Autores: 50</label
          >
        </div>
      </div>

      <!-- Affiliations -->
      <div class="mb-4">
        <div class="text-sm text-gray-700 mb-2 font-bold border-gray-400">Afiliaciones</div>
        <div class="space-y-2 p-2 rounded-2xl border-gray-400">
          <input type="checkbox" class="h-4 w-4 text-blue-600 border-gray-300 rounded mr-2" />
          <label class="text-sm text-gray-700">Mostrar Todas</label>
          <div class="flex items-center" *ngFor="let aff of affiliations">
            <input type="checkbox" class="h-4 w-4 text-blue-600 border-gray-300 rounded mr-2" />
            <label class="text-sm text-gray-700">{{ aff.nombre }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
